import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { createDeviceAdapter } from '@tldr/core/adapters/device';
import { createPreferencesAdapter } from '@tldr/core/adapters/preferences';

// Issue #455 D1 — Capacitor 플러그인 직접 import 대신 어댑터 경유.
// Vite resolve.extensions가 환경별 .native.ts / .web.ts 자동 선택.
const device = createDeviceAdapter();
const preferences = createPreferencesAdapter();

// English & Korean (primary languages)
import enCommon from './locales/en/common.json';
import enSettings from './locales/en/settings.json';
import enFeed from './locales/en/feed.json';
import enLogin from './locales/en/login.json';
import enDetail from './locales/en/detail.json';
import enSubscription from './locales/en/subscription.json';

import koCommon from './locales/ko/common.json';
import koSettings from './locales/ko/settings.json';
import koFeed from './locales/ko/feed.json';
import koLogin from './locales/ko/login.json';
import koDetail from './locales/ko/detail.json';
import koSubscription from './locales/ko/subscription.json';

// Additional 38 languages
import jaCommon from './locales/ja/common.json';
import jaSettings from './locales/ja/settings.json';
import jaFeed from './locales/ja/feed.json';
import jaLogin from './locales/ja/login.json';
import jaDetail from './locales/ja/detail.json';
import jaSubscription from './locales/ja/subscription.json';

import zhCNCommon from './locales/zh-CN/common.json';
import zhCNSettings from './locales/zh-CN/settings.json';
import zhCNFeed from './locales/zh-CN/feed.json';
import zhCNLogin from './locales/zh-CN/login.json';
import zhCNDetail from './locales/zh-CN/detail.json';
import zhCNSubscription from './locales/zh-CN/subscription.json';

import zhTWCommon from './locales/zh-TW/common.json';
import zhTWSettings from './locales/zh-TW/settings.json';
import zhTWFeed from './locales/zh-TW/feed.json';
import zhTWLogin from './locales/zh-TW/login.json';
import zhTWDetail from './locales/zh-TW/detail.json';
import zhTWSubscription from './locales/zh-TW/subscription.json';

import esCommon from './locales/es/common.json';
import esSettings from './locales/es/settings.json';
import esFeed from './locales/es/feed.json';
import esLogin from './locales/es/login.json';
import esDetail from './locales/es/detail.json';
import esSubscription from './locales/es/subscription.json';

import frCommon from './locales/fr/common.json';
import frSettings from './locales/fr/settings.json';
import frFeed from './locales/fr/feed.json';
import frLogin from './locales/fr/login.json';
import frDetail from './locales/fr/detail.json';
import frSubscription from './locales/fr/subscription.json';

import deCommon from './locales/de/common.json';
import deSettings from './locales/de/settings.json';
import deFeed from './locales/de/feed.json';
import deLogin from './locales/de/login.json';
import deDetail from './locales/de/detail.json';
import deSubscription from './locales/de/subscription.json';

import ptCommon from './locales/pt/common.json';
import ptSettings from './locales/pt/settings.json';
import ptFeed from './locales/pt/feed.json';
import ptLogin from './locales/pt/login.json';
import ptDetail from './locales/pt/detail.json';
import ptSubscription from './locales/pt/subscription.json';

import itCommon from './locales/it/common.json';
import itSettings from './locales/it/settings.json';
import itFeed from './locales/it/feed.json';
import itLogin from './locales/it/login.json';
import itDetail from './locales/it/detail.json';
import itSubscription from './locales/it/subscription.json';

import ruCommon from './locales/ru/common.json';
import ruSettings from './locales/ru/settings.json';
import ruFeed from './locales/ru/feed.json';
import ruLogin from './locales/ru/login.json';
import ruDetail from './locales/ru/detail.json';
import ruSubscription from './locales/ru/subscription.json';

import arCommon from './locales/ar/common.json';
import arSettings from './locales/ar/settings.json';
import arFeed from './locales/ar/feed.json';
import arLogin from './locales/ar/login.json';
import arDetail from './locales/ar/detail.json';
import arSubscription from './locales/ar/subscription.json';

import hiCommon from './locales/hi/common.json';
import hiSettings from './locales/hi/settings.json';
import hiFeed from './locales/hi/feed.json';
import hiLogin from './locales/hi/login.json';
import hiDetail from './locales/hi/detail.json';
import hiSubscription from './locales/hi/subscription.json';

import thCommon from './locales/th/common.json';
import thSettings from './locales/th/settings.json';
import thFeed from './locales/th/feed.json';
import thLogin from './locales/th/login.json';
import thDetail from './locales/th/detail.json';
import thSubscription from './locales/th/subscription.json';

import viCommon from './locales/vi/common.json';
import viSettings from './locales/vi/settings.json';
import viFeed from './locales/vi/feed.json';
import viLogin from './locales/vi/login.json';
import viDetail from './locales/vi/detail.json';
import viSubscription from './locales/vi/subscription.json';

import idCommon from './locales/id/common.json';
import idSettings from './locales/id/settings.json';
import idFeed from './locales/id/feed.json';
import idLogin from './locales/id/login.json';
import idDetail from './locales/id/detail.json';
import idSubscription from './locales/id/subscription.json';

import msCommon from './locales/ms/common.json';
import msSettings from './locales/ms/settings.json';
import msFeed from './locales/ms/feed.json';
import msLogin from './locales/ms/login.json';
import msDetail from './locales/ms/detail.json';
import msSubscription from './locales/ms/subscription.json';

import trCommon from './locales/tr/common.json';
import trSettings from './locales/tr/settings.json';
import trFeed from './locales/tr/feed.json';
import trLogin from './locales/tr/login.json';
import trDetail from './locales/tr/detail.json';
import trSubscription from './locales/tr/subscription.json';

import plCommon from './locales/pl/common.json';
import plSettings from './locales/pl/settings.json';
import plFeed from './locales/pl/feed.json';
import plLogin from './locales/pl/login.json';
import plDetail from './locales/pl/detail.json';
import plSubscription from './locales/pl/subscription.json';

import nlCommon from './locales/nl/common.json';
import nlSettings from './locales/nl/settings.json';
import nlFeed from './locales/nl/feed.json';
import nlLogin from './locales/nl/login.json';
import nlDetail from './locales/nl/detail.json';
import nlSubscription from './locales/nl/subscription.json';

import svCommon from './locales/sv/common.json';
import svSettings from './locales/sv/settings.json';
import svFeed from './locales/sv/feed.json';
import svLogin from './locales/sv/login.json';
import svDetail from './locales/sv/detail.json';
import svSubscription from './locales/sv/subscription.json';

import daCommon from './locales/da/common.json';
import daSettings from './locales/da/settings.json';
import daFeed from './locales/da/feed.json';
import daLogin from './locales/da/login.json';
import daDetail from './locales/da/detail.json';
import daSubscription from './locales/da/subscription.json';

import noCommon from './locales/no/common.json';
import noSettings from './locales/no/settings.json';
import noFeed from './locales/no/feed.json';
import noLogin from './locales/no/login.json';
import noDetail from './locales/no/detail.json';
import noSubscription from './locales/no/subscription.json';

import fiCommon from './locales/fi/common.json';
import fiSettings from './locales/fi/settings.json';
import fiFeed from './locales/fi/feed.json';
import fiLogin from './locales/fi/login.json';
import fiDetail from './locales/fi/detail.json';
import fiSubscription from './locales/fi/subscription.json';

import elCommon from './locales/el/common.json';
import elSettings from './locales/el/settings.json';
import elFeed from './locales/el/feed.json';
import elLogin from './locales/el/login.json';
import elDetail from './locales/el/detail.json';
import elSubscription from './locales/el/subscription.json';

import csCommon from './locales/cs/common.json';
import csSettings from './locales/cs/settings.json';
import csFeed from './locales/cs/feed.json';
import csLogin from './locales/cs/login.json';
import csDetail from './locales/cs/detail.json';
import csSubscription from './locales/cs/subscription.json';

import huCommon from './locales/hu/common.json';
import huSettings from './locales/hu/settings.json';
import huFeed from './locales/hu/feed.json';
import huLogin from './locales/hu/login.json';
import huDetail from './locales/hu/detail.json';
import huSubscription from './locales/hu/subscription.json';

import roCommon from './locales/ro/common.json';
import roSettings from './locales/ro/settings.json';
import roFeed from './locales/ro/feed.json';
import roLogin from './locales/ro/login.json';
import roDetail from './locales/ro/detail.json';
import roSubscription from './locales/ro/subscription.json';

import bgCommon from './locales/bg/common.json';
import bgSettings from './locales/bg/settings.json';
import bgFeed from './locales/bg/feed.json';
import bgLogin from './locales/bg/login.json';
import bgDetail from './locales/bg/detail.json';
import bgSubscription from './locales/bg/subscription.json';

import hrCommon from './locales/hr/common.json';
import hrSettings from './locales/hr/settings.json';
import hrFeed from './locales/hr/feed.json';
import hrLogin from './locales/hr/login.json';
import hrDetail from './locales/hr/detail.json';
import hrSubscription from './locales/hr/subscription.json';

import skCommon from './locales/sk/common.json';
import skSettings from './locales/sk/settings.json';
import skFeed from './locales/sk/feed.json';
import skLogin from './locales/sk/login.json';
import skDetail from './locales/sk/detail.json';
import skSubscription from './locales/sk/subscription.json';

import slCommon from './locales/sl/common.json';
import slSettings from './locales/sl/settings.json';
import slFeed from './locales/sl/feed.json';
import slLogin from './locales/sl/login.json';
import slDetail from './locales/sl/detail.json';
import slSubscription from './locales/sl/subscription.json';

import ukCommon from './locales/uk/common.json';
import ukSettings from './locales/uk/settings.json';
import ukFeed from './locales/uk/feed.json';
import ukLogin from './locales/uk/login.json';
import ukDetail from './locales/uk/detail.json';
import ukSubscription from './locales/uk/subscription.json';

import srCommon from './locales/sr/common.json';
import srSettings from './locales/sr/settings.json';
import srFeed from './locales/sr/feed.json';
import srLogin from './locales/sr/login.json';
import srDetail from './locales/sr/detail.json';
import srSubscription from './locales/sr/subscription.json';

import heCommon from './locales/he/common.json';
import heSettings from './locales/he/settings.json';
import heFeed from './locales/he/feed.json';
import heLogin from './locales/he/login.json';
import heDetail from './locales/he/detail.json';
import heSubscription from './locales/he/subscription.json';

import bnCommon from './locales/bn/common.json';
import bnSettings from './locales/bn/settings.json';
import bnFeed from './locales/bn/feed.json';
import bnLogin from './locales/bn/login.json';
import bnDetail from './locales/bn/detail.json';
import bnSubscription from './locales/bn/subscription.json';

import etCommon from './locales/et/common.json';
import etSettings from './locales/et/settings.json';
import etFeed from './locales/et/feed.json';
import etLogin from './locales/et/login.json';
import etDetail from './locales/et/detail.json';
import etSubscription from './locales/et/subscription.json';

import lvCommon from './locales/lv/common.json';
import lvSettings from './locales/lv/settings.json';
import lvFeed from './locales/lv/feed.json';
import lvLogin from './locales/lv/login.json';
import lvDetail from './locales/lv/detail.json';
import lvSubscription from './locales/lv/subscription.json';

import ltCommon from './locales/lt/common.json';
import ltSettings from './locales/lt/settings.json';
import ltFeed from './locales/lt/feed.json';
import ltLogin from './locales/lt/login.json';
import ltDetail from './locales/lt/detail.json';
import ltSubscription from './locales/lt/subscription.json';

import swCommon from './locales/sw/common.json';
import swSettings from './locales/sw/settings.json';
import swFeed from './locales/sw/feed.json';
import swLogin from './locales/sw/login.json';
import swDetail from './locales/sw/detail.json';
import swSubscription from './locales/sw/subscription.json';

import { SUPPORTED_LANGUAGE_CODES } from './languages';

const DEFAULT_LANGUAGE = 'en';
const LANGUAGE_PREFERENCE_KEY = 'user_language';

/**
 * 사용자 선호 언어를 감지합니다.
 */
async function detectLanguage(): Promise<string> {
  try {
    // Issue #455 simplify pass — preferences.get과 device.getLanguageCode는 의존성 없음.
    // Promise.all로 병렬 실행하여 부팅 latency 단축 (특히 native IPC 왕복).
    const [savedLanguage, { value: systemLanguage }] = await Promise.all([
      preferences.get(LANGUAGE_PREFERENCE_KEY),
      device.getLanguageCode(),
    ]);

    if (savedLanguage && SUPPORTED_LANGUAGE_CODES.includes(savedLanguage)) {
      return savedLanguage;
    }

    const languageCode = systemLanguage?.split('-')[0] || DEFAULT_LANGUAGE;

    if (SUPPORTED_LANGUAGE_CODES.includes(languageCode)) {
      return languageCode;
    }

    return DEFAULT_LANGUAGE;
  } catch (error) {
    console.error('Failed to detect language:', error);
    return DEFAULT_LANGUAGE;
  }
}

export async function initializeI18n() {
  const language = await detectLanguage();

  await i18n.use(initReactI18next).init({
    lng: language,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: [...SUPPORTED_LANGUAGE_CODES],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    resources: {
      en: { common: enCommon.common, settings: enSettings.settings, feed: enFeed.feed, login: enLogin.login, detail: enDetail.detail, subscription: enSubscription.subscription },
      ko: { common: koCommon.common, settings: koSettings.settings, feed: koFeed.feed, login: koLogin.login, detail: koDetail.detail, subscription: koSubscription.subscription },
      ja: { common: jaCommon.common, settings: jaSettings.settings, feed: jaFeed.feed, login: jaLogin.login, detail: jaDetail.detail, subscription: jaSubscription.subscription },
      'zh-CN': { common: zhCNCommon.common, settings: zhCNSettings.settings, feed: zhCNFeed.feed, login: zhCNLogin.login, detail: zhCNDetail.detail, subscription: zhCNSubscription.subscription },
      'zh-TW': { common: zhTWCommon.common, settings: zhTWSettings.settings, feed: zhTWFeed.feed, login: zhTWLogin.login, detail: zhTWDetail.detail, subscription: zhTWSubscription.subscription },
      es: { common: esCommon.common, settings: esSettings.settings, feed: esFeed.feed, login: esLogin.login, detail: esDetail.detail, subscription: esSubscription.subscription },
      fr: { common: frCommon.common, settings: frSettings.settings, feed: frFeed.feed, login: frLogin.login, detail: frDetail.detail, subscription: frSubscription.subscription },
      de: { common: deCommon.common, settings: deSettings.settings, feed: deFeed.feed, login: deLogin.login, detail: deDetail.detail, subscription: deSubscription.subscription },
      pt: { common: ptCommon.common, settings: ptSettings.settings, feed: ptFeed.feed, login: ptLogin.login, detail: ptDetail.detail, subscription: ptSubscription.subscription },
      it: { common: itCommon.common, settings: itSettings.settings, feed: itFeed.feed, login: itLogin.login, detail: itDetail.detail, subscription: itSubscription.subscription },
      ru: { common: ruCommon.common, settings: ruSettings.settings, feed: ruFeed.feed, login: ruLogin.login, detail: ruDetail.detail, subscription: ruSubscription.subscription },
      ar: { common: arCommon.common, settings: arSettings.settings, feed: arFeed.feed, login: arLogin.login, detail: arDetail.detail, subscription: arSubscription.subscription },
      hi: { common: hiCommon.common, settings: hiSettings.settings, feed: hiFeed.feed, login: hiLogin.login, detail: hiDetail.detail, subscription: hiSubscription.subscription },
      th: { common: thCommon.common, settings: thSettings.settings, feed: thFeed.feed, login: thLogin.login, detail: thDetail.detail, subscription: thSubscription.subscription },
      vi: { common: viCommon.common, settings: viSettings.settings, feed: viFeed.feed, login: viLogin.login, detail: viDetail.detail, subscription: viSubscription.subscription },
      id: { common: idCommon.common, settings: idSettings.settings, feed: idFeed.feed, login: idLogin.login, detail: idDetail.detail, subscription: idSubscription.subscription },
      ms: { common: msCommon.common, settings: msSettings.settings, feed: msFeed.feed, login: msLogin.login, detail: msDetail.detail, subscription: msSubscription.subscription },
      tr: { common: trCommon.common, settings: trSettings.settings, feed: trFeed.feed, login: trLogin.login, detail: trDetail.detail, subscription: trSubscription.subscription },
      pl: { common: plCommon.common, settings: plSettings.settings, feed: plFeed.feed, login: plLogin.login, detail: plDetail.detail, subscription: plSubscription.subscription },
      nl: { common: nlCommon.common, settings: nlSettings.settings, feed: nlFeed.feed, login: nlLogin.login, detail: nlDetail.detail, subscription: nlSubscription.subscription },
      sv: { common: svCommon.common, settings: svSettings.settings, feed: svFeed.feed, login: svLogin.login, detail: svDetail.detail, subscription: svSubscription.subscription },
      da: { common: daCommon.common, settings: daSettings.settings, feed: daFeed.feed, login: daLogin.login, detail: daDetail.detail, subscription: daSubscription.subscription },
      no: { common: noCommon.common, settings: noSettings.settings, feed: noFeed.feed, login: noLogin.login, detail: noDetail.detail, subscription: noSubscription.subscription },
      fi: { common: fiCommon.common, settings: fiSettings.settings, feed: fiFeed.feed, login: fiLogin.login, detail: fiDetail.detail, subscription: fiSubscription.subscription },
      el: { common: elCommon.common, settings: elSettings.settings, feed: elFeed.feed, login: elLogin.login, detail: elDetail.detail, subscription: elSubscription.subscription },
      cs: { common: csCommon.common, settings: csSettings.settings, feed: csFeed.feed, login: csLogin.login, detail: csDetail.detail, subscription: csSubscription.subscription },
      hu: { common: huCommon.common, settings: huSettings.settings, feed: huFeed.feed, login: huLogin.login, detail: huDetail.detail, subscription: huSubscription.subscription },
      ro: { common: roCommon.common, settings: roSettings.settings, feed: roFeed.feed, login: roLogin.login, detail: roDetail.detail, subscription: roSubscription.subscription },
      bg: { common: bgCommon.common, settings: bgSettings.settings, feed: bgFeed.feed, login: bgLogin.login, detail: bgDetail.detail, subscription: bgSubscription.subscription },
      hr: { common: hrCommon.common, settings: hrSettings.settings, feed: hrFeed.feed, login: hrLogin.login, detail: hrDetail.detail, subscription: hrSubscription.subscription },
      sk: { common: skCommon.common, settings: skSettings.settings, feed: skFeed.feed, login: skLogin.login, detail: skDetail.detail, subscription: skSubscription.subscription },
      sl: { common: slCommon.common, settings: slSettings.settings, feed: slFeed.feed, login: slLogin.login, detail: slDetail.detail, subscription: slSubscription.subscription },
      uk: { common: ukCommon.common, settings: ukSettings.settings, feed: ukFeed.feed, login: ukLogin.login, detail: ukDetail.detail, subscription: ukSubscription.subscription },
      sr: { common: srCommon.common, settings: srSettings.settings, feed: srFeed.feed, login: srLogin.login, detail: srDetail.detail, subscription: srSubscription.subscription },
      he: { common: heCommon.common, settings: heSettings.settings, feed: heFeed.feed, login: heLogin.login, detail: heDetail.detail, subscription: heSubscription.subscription },
      bn: { common: bnCommon.common, settings: bnSettings.settings, feed: bnFeed.feed, login: bnLogin.login, detail: bnDetail.detail, subscription: bnSubscription.subscription },
      et: { common: etCommon.common, settings: etSettings.settings, feed: etFeed.feed, login: etLogin.login, detail: etDetail.detail, subscription: etSubscription.subscription },
      lv: { common: lvCommon.common, settings: lvSettings.settings, feed: lvFeed.feed, login: lvLogin.login, detail: lvDetail.detail, subscription: lvSubscription.subscription },
      lt: { common: ltCommon.common, settings: ltSettings.settings, feed: ltFeed.feed, login: ltLogin.login, detail: ltDetail.detail, subscription: ltSubscription.subscription },
      sw: { common: swCommon.common, settings: swSettings.settings, feed: swFeed.feed, login: swLogin.login, detail: swDetail.detail, subscription: swSubscription.subscription },
    },
  });

  return i18n;
}

export { SUPPORTED_LANGUAGE_CODES as SUPPORTED_LANGUAGES, LANGUAGE_PREFERENCE_KEY };
export default i18n;
